import React from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import { Modal, Tabs } from 'antd'
import { withFormik } from 'formik'
import * as yup from 'yup'

import { GET_HERO_BY_ID } from '../../../../graphql/queries'

import BinForm from '../BinForm'
import BinDetails from '../BinDetails'

const validationSchema = () =>
  yup.object().shape({
    binId: yup.string().required(),
    macAddress: yup.string().required(),
    password: yup
      .string()
      .min(6)
      .when('id', (id, passSchema) => (id ? passSchema : passSchema.required()))
  })

const handleSubmit = async (values, { props, setSubmitting, resetForm }) => {
  const { onCreate, onEdit, onClose } = props

  setSubmitting(true)

  if (values.id) {
    await onEdit(values.id, {
      ...values,
      id: undefined
    })

    resetForm()
  } else {
    await onCreate({ ...values, heroType: 'CIRCULAR_BIN' })

    resetForm()
  }

  onClose()
  setSubmitting(false)
}

export const BinModal = ({
  data,
  values,
  visible,
  onClose,
  loading,
  handleChange,
  handleBlur,
  handleSubmit,
  touched,
  errors,
  options
}) => {
  if (!data.loading) {
    return (
      <Modal
        visible={visible}
        title={values.id ? 'Edit Bin' : 'Create a new Bin'}
        okText={values.id ? 'Save' : 'Create'}
        onCancel={() => onClose()}
        onOk={handleSubmit}
        confirmLoading={loading}
      >
        {!data.loading && (
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="Circular Bin Profile" key="1">
              <BinForm
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
                data={data}
                options={options || {}}
              />
            </Tabs.TabPane>
            {data.hero && (
              <Tabs.TabPane tab="Circular Bin Details" key="2">
                <BinDetails data={data.hero}></BinDetails>
              </Tabs.TabPane>
            )}
          </Tabs>
        )}
      </Modal>
    )
  } else {
    return <div />
  }
}

BinModal.propTypes = {
  data: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired
}

export default compose(
  graphql(GET_HERO_BY_ID, {
    options: ({ data }) => {
      return {
        variables: {
          id: data.id || 0
        },
        fetchPolicy: 'network-only'
      }
    }
  }),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: ({ data }) => {
      return {
        id: data.hero && data.hero.id,
        binId: (data.hero && data.hero.binId) || '',
        password: '',
        macAddress: (data.hero && data.hero.macAddress) || '',
        status: (data.hero && data.hero.status) || 'PENDING'
      }
    },
    handleSubmit,
    validationSchema,
    displayName: 'BinModal'
  })
)(BinModal)



// WEBPACK FOOTER //
// ./src/pages/Bin/components/BinModal/index.js